import React from 'react';
import imagemContato from '../assets/__hero-elaine-profissional.webp';
import imagemFundo from '../assets/background-contato.jpg';

export default function Contato() {
  return (
    <>
      <section
        id="contato"
        className="py-5 position-relative text-dark"
        style={{
          backgroundImage: `url(${imagemFundo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="text-center">
            <div className="row align-items-center">

              {/* IMAGEM AJUSTADA */}
              <div className="col-md-6 mb-4 mb-md-0">
                <img
                  src={imagemContato}
                  alt="Psicóloga Elaine Rampazzo – atendimento online"
                  loading="lazy"
                  decoding="async"
                  className="img-fluid"
                  style={{
                    maxHeight: '520px',
                    maxWidth: '460px',
                    width: '100%',
                    objectFit: 'contain',
                    borderRadius: '24px', // 🔥 mais suave
                    boxShadow: '0 16px 40px rgba(0,0,0,0.08)', // 🔥 mais elegante
                  }}
                />
              </div>

              {/* TEXTO */}
              <div className="col-md-6 d-flex flex-column align-items-center">

                <h2 className="fw-bold mb-3 text-marrom-suave">
                  Conte comigo nessa jornada
                </h2>

                <p className="mb-4" style={{ lineHeight: '1.7' }}>
                  Este é um espaço de acolhimento, escuta e cuidado, criado para ajudar você
                  a compreender melhor suas emoções, enfrentar desafios e viver cada fase da
                  vida com mais equilíbrio, leveza e autenticidade.
                </p>

                <p className="mb-4 fst-italic">
                  Ansiedade, depressão, relacionamentos, luto, autoconhecimento, maternidade,
                  paternidade, carreira ou momentos de mudança: a terapia pode ser um caminho
                  de apoio e transformação.
                </p>

                {/* BOTÃO */}
                <a
                  href="https://wa.me/5511962382055"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-cta d-inline-flex align-items-center gap-2 px-4 py-3 shadow-lg mb-4"
                  style={{ fontSize: '1.05rem' }}
                >
                  <i className="bi bi-whatsapp fs-5"></i>
                  Agendar conversa pelo WhatsApp
                </a>

                <div className="text-center">
                  <p className="mb-1 fw-bold text-marrom-suave">Elaine Rampazzo</p>
                  <p className="mb-1 text-muted">Psicóloga Clínica</p>
                  <p className="mb-1 text-muted">CRP 06/108903</p>
                  <p className="mb-0 text-muted">elaine.psico23@gmail.com</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}